<template>
  <div class="login-container">
    <a-form
      :model="loginRequest"
      autocomplete="off"
      class="login-form"
      @submit="submitLogin"
    >
      <h2 class="form-title">后台管理系统</h2>
      <a-form-item label="账号">
        <a-input
          v-model:value="loginRequest.account"
          placeholder="请输入账号"
          clearable
        />
      </a-form-item>
      <a-form-item label="密码">
        <a-input-password
          v-model:value="loginRequest.password"
          type="password"
          placeholder="请输入密码"
        />
      </a-form-item>
      <a-form-item label="验证码" class="code-item">
        <div class="code-container">
          <a-input
            v-model:value="loginRequest.code"
            placeholder="请输入验证码"
            clearable
          />
          <div class="code-image" @click="refreshCaptcha">
            <img v-if="captchaImage" :src="captchaImage" alt="验证码" />
            <span v-else>加载中...</span>
          </div>
        </div>
      </a-form-item>
      <div class="remember-and-login">
        <a-checkbox v-model:checked="remember" class="remember-me"
          >记住我
        </a-checkbox>
        <a-button
          type="primary"
          class="login-btn"
          html-type="submit"
          :loading="loading"
        >
          登录
        </a-button>
      </div>
    </a-form>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { AdminService } from "@/api/services/AdminService";
import { AdminLoginRequest } from "@/api/models/admin/AdminLoginRequest";
import router from "@/router";
import axios from "axios";
import { message } from "ant-design-vue";

const remember = ref(false);
const loading = ref(false);
const captchaImage = ref<string>("");

const loginRequest = reactive<AdminLoginRequest>({
  account: "",
  password: "",
  id: "",
  code: "",
});

const submitLogin = async () => {
  loading.value = true;
  const res = await AdminService.Login(loginRequest);
  if (res.code === 0) {
    if (remember.value) {
      localStorage.setItem("remember", "true");
      localStorage.setItem("account", loginRequest.account);
      localStorage.setItem("password", loginRequest.password);
    } else {
      localStorage.setItem("remember", "false");
    }
    localStorage.setItem("A-Token", res.data);
    loading.value = false;
    message.success("登录成功");
    await router.push({ path: "/", replace: true });
    setTimeout(() => location.reload(), 500);
  } else {
    message.error(res.msg);
    loading.value = false;
    await refreshCaptcha();
  }
};

const handleCode = async () => {
  const res = await AdminService.GetCode();
  loginRequest.id = res.data;
};

const handleImage = async () => {
  const res = await axios.post(
    process.env.VUE_APP_BASE_URL + "/admin/image",
    { id: loginRequest.id },
    { responseType: "blob" }
  );
  const blob = new Blob([res.data], { type: res.headers["content-type"] });
  captchaImage.value = URL.createObjectURL(blob);
};

const refreshCaptcha = async () => {
  await handleCode();
  await handleImage();
};

onMounted(() => {
  if (localStorage.getItem("remember") === "true") {
    loginRequest.account = localStorage.getItem("account") ?? "";
    loginRequest.password = localStorage.getItem("password") ?? "";
    remember.value = true;
  }
  refreshCaptcha();
});
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100vh;
  background-image: url("@/assets/login.jpg");
  background-size: cover;
  background-position: center;
}

.login-form {
  width: 450px;
  padding: 40px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  top: 33.33%;
  transform: translateY(-50%);
}

.login-form:hover {
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

.form-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 24px;
}

.code-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.code-image {
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 4px;
  background-color: #fff;
  transition: border-color 0.3s ease;
}

.code-image:hover {
  border-color: #409eff;
}

.code-image img {
  width: 100px;
  height: 40px;
}

.remember-and-login {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
}

.remember-me {
  margin-right: 10px;
  flex-shrink: 0;
}

.login-btn {
  flex-grow: 1;
  width: 48%;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.login-btn:hover {
  background-color: #409eff;
  transform: translateY(-2px);
}
</style>
